import { useState } from 'react';

import { Api } from '../../api/api';

import type { ForgotPasswordState } from './ForgotPasswordState';
import { canSubmit } from './ForgotPasswordState';

/** Mirrors android/…/Screens/ForgotPassword/ForgotPasswordViewModel.kt. */
export function useForgotPassword() {
  const [state, setState] = useState<ForgotPasswordState>({
    email: '',
    isSubmitting: false,
    isSent: false,
    error: null,
  });

  return {
    state,
    email: (email: string): void => setState((current) => ({ ...current, email, error: null })),

    submit: async (): Promise<void> => {
      if (!canSubmit(state)) return;

      setState((current) => ({ ...current, isSubmitting: true, error: null }));

      const result = await Api.requestPasswordReset(state.email.trim());

      if (result.ok) {
        // Success means "the request was accepted", never "the address exists" — the API will not say,
        // and neither will this screen.
        setState((current) => ({ ...current, isSubmitting: false, isSent: true }));

        return;
      }

      // Only a genuine failure to reach the API lands here; a malformed address is the one thing the
      // server does reject, and its message is the API's own.
      setState((current) => ({ ...current, isSubmitting: false, error: result.error.message }));
    },
  };
}
